// extracted by mini-css-extract-plugin
export default {"welcomeBox":"login_welcomeBox__zLRZ5","loginBox":"login_loginBox__c2uxT","loginButton":"login_loginButton__As1Gh"};